import { observable, computed } from "mobx";
import PasswordResetDisambiguation from "../models/PasswordResetDisambiguation";
import PasswordResetDisambiguationRepository from "~/repository/PasswordResetDisambiguationRepository";
import PasswordResetRepository from "~/repository/PasswordResetRepository";

class ForgotPasswordStore {
  /**
   * @type {string}
   */
  @observable usernameOrEmail = "";

  @observable isLoading = false;

  @observable isDisambiguation = false;

  @observable passwordResetDisambiguation = [];

  @observable isResetPasswordError = false;

  @observable resetPasswordSuccessMessage = "";

  @observable isResetPasswordSuccess = false;

  /**
   * @property {PasswordResetDisambiguationRepository}
   */
  passwordResetDisambiguationRepository;

  /**
   * @property {PasswordResetRepository}
   */
  passwordResetRepository;

  @computed
  get canResetDisambiguationPassword() {
    return this.passwordResetDisambiguation.some(
      passwordResetDisambiguation =>
        passwordResetDisambiguation.checked && !passwordResetDisambiguation.isResetPasswordSuccess,
    );
  }

  constructor() {
    this.passwordResetDisambiguationRepository = new PasswordResetDisambiguationRepository();
    this.passwordResetRepository = new PasswordResetRepository();
  }

  resetPasswordForUsername(username) {
    this.isResetPasswordError = false;
    this.isResetPasswordSuccess = false;

    return this.passwordResetRepository.create({ usernameOrEmail: username });
  }

  resetPasswordForCheckedDisambiguation() {
    const promises = [];

    this.passwordResetDisambiguation.forEach((passwordResetDisambiguation, index) => {
      if (passwordResetDisambiguation.checked && !passwordResetDisambiguation.isResetPasswordSuccess) {
        const promise = this.resetPasswordForUsername(passwordResetDisambiguation.username)
          .then(data => {
            this.passwordResetDisambiguation[index].isResetPasswordError = false;
            this.passwordResetDisambiguation[index].isResetPasswordSuccess = true;
            this.passwordResetDisambiguation[index].resetPasswordMessage = data.data.message;
          })
          .catch(data => {
            this.passwordResetDisambiguation[index].isResetPasswordError = true;
            this.passwordResetDisambiguation[index].isResetPasswordSuccess = false;
            this.passwordResetDisambiguation[index].resetPasswordMessage = data.message;
          });

        promises.push(promise);
      }
    });

    return Promise.all(promises);
  }

  loadEmailDisambiguation(email) {
    this.isDisambiguation = true;

    return this.passwordResetDisambiguationRepository.create({ email }).then(data => {
      this.passwordResetDisambiguation = [];
      data.data.forEach(user => {
        this.passwordResetDisambiguation.push(new PasswordResetDisambiguation(user));
      });
    });
  }
}

export default ForgotPasswordStore;
